// extracted by mini-css-extract-plugin
export default {"form":"LocalPickupForm_form__WVemv","column":"LocalPickupForm_column__AKzeS"};